import React from 'react'
import KeyPickupDrop from '../components/keyPickupDropEvents/KeyPickupDrop'

const KeyDropPickupPage = () => {
  return (
    <KeyPickupDrop />
  )
}

export default KeyDropPickupPage
